import { render, staticRenderFns } from "./biDetailJoin.vue?vue&type=template&id=43211981&scoped=true&"
import script from "./biDetailJoin.vue?vue&type=script&lang=js&"
export * from "./biDetailJoin.vue?vue&type=script&lang=js&"
import style0 from "./biDetailJoin.vue?vue&type=style&index=0&id=43211981&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43211981",
  null
  
)

export default component.exports